import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiListResponse, ApiResponse } from '../lib/response';
import { Role } from '../models/role';

export class RoleGrants {
  [key: string]: any;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class RoleGrantBundle {
  [key: string]: any;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class RoleService extends BaseService<Role> {
  override model = Role;
  override modelName = 'role';
  override modelLabel = 'Role';

  async grants(): Promise<ApiResponse<RoleGrants>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/grants`,
    });

    return await this.requestItem(request, RoleGrants as any);
  }

  async bundles(): Promise<ApiListResponse<RoleGrantBundle>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/bundles`,
    });

    return await this.requestList(request, RoleGrantBundle as any);
  }

  async builtIns(): Promise<ApiListResponse<Role>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/builtIns`,
    });

    return await this.requestList(request, Role);
  }
}
